import styled from 'styled-components';

import { colors, fontWeights } from 'theme/theme';

export const DetailsListItemHolder = styled.div`
  display: flex;
  gap: 8px;
`;

export const DetailsListItemBody = styled.div`
  display: flex;
  flex-direction: column;
  font-size: 16px;
`;

export const DetailsListItemFirstLine = styled.div`
  display: flex;
  align-items: center;
  color: ${colors.darkContentGrey};
`;

export const DetailsListItemTitle = styled.span`
  display: inline-flex;
  font-weight: ${fontWeights.semiBold};
  margin-right: 4px;
`;

export const DetailsListItemValue = styled.span`
  display: inline-flex;
  align-items: center;
`;

export const DetailsListItemAdditionalText = styled.div`
  color: ${colors.lightContentGrey};
  font-weight: ${fontWeights.semiBold};
  font-style: italic;
`;
